import { State } from "@src/models";
import { IncomingHttpHeaders, IncomingMessage, ServerResponse } from "http";
import { Url } from "url";
import { Session } from ".";

export class Request {
	method:
		| "GET"
		| "POST"
		| "PUT"
		| "DELETE"
		| "PATCH"
		| "HEAD"
		| "OPTIONS"
		| "CONNECT"
		| "TRACE";

	path?: string | null;

	url: string;

	/**
	 * The msisdn of the user
	 */
	msisdn?: string;

	/**
	 * USSD service short code. Set only for Emergent Technology USSD
	 */
	serviceCode?: string;

	/**
	 * The input from the user
	 */
	input?: string;

	headers: IncomingHttpHeaders;

	body: any;

	query?: Record<string, string>;

	/**
	 * Current USSD state. Null until the request is processed by the middlewares
	 */
	state: State;

	/**
	 * Current session. Null until the request is processed by the middlewares
	 */
	session: Session;

	constructor(_url: Url, req: IncomingMessage) {
		this.method = req.method as any;
		this.path = _url.pathname;
		this.url = _url.href;
		this.headers = req.headers;
		this.query = _url.query as Record<string, string>;
	}
}

export class Response extends ServerResponse {
	data: Record<string, any> | any;
}
